import { isLogin as _isLogin, isOpenAuth, isResetPasswordAtom } from "@models/state/auth-modal";
import { openPopupAtom } from "@models/state/cart/index";
import { useAtom } from "jotai";

export function useAuth() {
  const [isOpen, setIsOpen] = useAtom(isOpenAuth);
  const [isLogin, setIsLogin] = useAtom(_isLogin);
  const [isResetPassword, setIsResetPassword] = useAtom(isResetPasswordAtom);
  const [isPopup, setIsPopup] = useAtom(openPopupAtom)


  function openRegister() {
    setIsOpen(true);
    setIsLogin(false);
    setIsResetPassword(false);
  }

  function openResetPassword(){
    setIsOpen(true);
    setIsLogin(true);
    setIsResetPassword(true);
    setIsPopup(false)
  }

  function openLogin() {
    setIsOpen(true);
    setIsLogin(true);
    setIsResetPassword(false);
    setIsPopup(false)
  }

  function closeAuth() {
    setIsOpen(false);
  }

  return {
    models: {
      isOpen,
      isLogin,
      isResetPassword,
    },
    operations: {
      openResetPassword,
      setIsResetPassword,
      openRegister,
      setIsLogin,
      openLogin,
      closeAuth,
    },
  };
}
